import request from '@/api/request'

export function getBanners() {
    return request({
        url: '/banners',
        method: 'get',
    })
}

export function apply(params) {
    return request({
        url: '/apply',
        method: 'post',
        data: params
    })
}